
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { WinoSharedModule } from './modules/wino-shared/wino-shared.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HttpClientInterceptor } from './utilities/http-client.interceptor';
import { AppInitializerService } from './services/app-initializer.service';

import { PageNotFoundComponent } from './components/generic/page-not-found/page-not-found.component';
import { GenericErrorComponent } from './components/generic/generic-error/generic-error.component';
import { HeaderComponent } from './components/header/header.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { FooterMenuComponent } from './components/footer/footer-menu/footer-menu.component';
import { PrivacyPolicyComponent } from './components/footer/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './components/footer/terms-of-service/terms-of-service.component';
import { ContactsComponent } from './components/footer/contacts/contacts.component';
import { BeginComponent } from './components/body/exercices/begin/begin.component';
import { ReactiveJSComponent } from './components/body/exercices/reactive-js/reactive-js.component';
import { ServerComponent } from './components/body/exercices/server/server.component';
import { ServersComponent } from './components/body/exercices/servers/servers.component';
import { TitleBarComponent } from './components/title-bar/title-bar.component';

@NgModule({
    declarations: [
        AppComponent,
        FooterMenuComponent,
        PageNotFoundComponent,
        NavBarComponent,
        HeaderComponent,
        BeginComponent,
        ReactiveJSComponent,
        GenericErrorComponent,
        PrivacyPolicyComponent,
        TermsOfServiceComponent,
        ContactsComponent,
        ServerComponent,
        ServersComponent,
        TitleBarComponent,
    ],
    imports: [
        FormsModule,
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        WinoSharedModule
  ],
  exports: [
  ],
  providers: [
    { provide: APP_INITIALIZER, multi: true, deps: [AppInitializerService], useFactory: (appInitializerService: AppInitializerService) => () => appInitializerService.start() },
    { provide: HTTP_INTERCEPTORS, useClass: HttpClientInterceptor, multi: true },
    // provideNgxWebstorage(
	// 	withNgxWebstorageConfig({ separator: ':', caseSensitive: true }),
	// 	withLocalStorage(),
	// 	withSessionStorage()
	// )
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
